module.exports = __webpack_public_path__ + "media/images/home/teacher_icon-98594050f7e9102f46b649eeb1e64a3f.svg";